module.exports = __webpack_public_path__ + "static/img/step-1.bf5a21dc.png";